import { IApplicationState } from 'shared/types/redux';

export const selectIsUnfinishedAnketaModalOpen = (state: IApplicationState) =>
  state.landing.unfinishedAnketaModal.isOpen;

export const selectUnfinishedAnketaModalPath = (state: IApplicationState) => state.landing.unfinishedAnketaModal.path;

export const selectUnfinishedAnketaModalPlace = (state: IApplicationState) => state.landing.unfinishedAnketaModal.place;
